export default __webpack_public_path__ + "static/media/background.35b92505.png";